import { Injectable } from '@angular/core';
import {ApiBaseService} from "libs/shared-services/src/lib/api-base.service";
import {ToasterService} from "libs/shared-services/src/lib/toaster.service";

import {catchError, map, Observable, of} from "rxjs";
import { LocaleService } from 'libs/shared-services/src/lib/locale.service';
import { BaseLoadingService } from 'libs/shared-services/src/lib/base-loading';
import { environment } from 'apps/restaurant/src/environments/environment';
import { StripeAccountSessionResponse } from '../model/stripe-account-session-response';
import { RestaurantFinanceStateService } from '../data-store/restaurant-finance.state';
import { RestaurantFinancialStatusResponse } from '../model/restaurant-financial-status-response';

@Injectable({
    providedIn: 'root',
})
export class RestaurantFinanceService extends BaseLoadingService {

    constructor(
        private apiService: ApiBaseService,
        private toasterService: ToasterService,
        private localeService: LocaleService,
        private financeStateService: RestaurantFinanceStateService
    ) {
        super();
        this.setFinished();
    }

    public requestStripeAccountCreation$(): Observable<boolean> {
        const apiCall = this.apiService.post(environment.API_POST_STRIPE_CREATE_ACCOUNT, {
            // empty request
        });

        return apiCall.pipe(
            map((res) => {
                //const resParsed = Object.assign(new Something(), res);
                this.toasterService.showSuccess("",this.localeService.translate("Stripe Account Successfully created"));
                return true;
            }),
            catchError((err: any, caught: Observable<any>): Observable<any> => {
                this.toasterService.showError("Error", err?.error?.message);
                return of(false);
            })
       );
    }

    public requestStripeAccountSession$(): Observable<boolean> {
        const apiCall = this.apiService.post(environment.API_POST_STRIPE_CREATE_ACCOUNT_SESSION, {
            // empty request
        });

        return apiCall.pipe(
            map((res) => {
                const parsed = Object.assign(new StripeAccountSessionResponse(), res);
                this.financeStateService.setSessionData(parsed);
                this.toasterService.showSuccess("",this.localeService.translate("Received client secret"));
                return true;
            }),
            catchError((err: any, caught: Observable<any>): Observable<any> => {
                this.toasterService.showError("Error", err?.error?.message);
                return of(false);
            })
       );
    }

    public requestFinancialStatus$(): Observable<boolean> {
        const apiCall = this.apiService.get(environment.API_GET_RESTAURANT_FINANCIAL_STATUS);

        return apiCall.pipe(
            map((res) => {
                const parsed = Object.assign(new RestaurantFinancialStatusResponse(), res);
                parsed.currentlyDue = parsed.currentlyDue || [];
                parsed.pendingVerification = parsed.pendingVerification || [];
                parsed.disabledReason = parsed.disabledReason || "";
                parsed.currency = (parsed.currency || "").toUpperCase();
                this.financeStateService.setFinancialData(parsed);
                return true;
            }),
            catchError((err: any, caught: Observable<any>): Observable<any> => {
                this.toasterService.showError("Error", err?.error?.message);
                return of(false);
            })
       );
    }

    public getFinancialData$(): Observable<RestaurantFinancialStatusResponse> {
        return this.financeStateService.getFinancialData$();
    }

    public getFinancialData(): RestaurantFinancialStatusResponse {
        return this.financeStateService.getFinancialData();
    }

    public resetFinancialData() {
        this.financeStateService.setFinancialData(new RestaurantFinancialStatusResponse());
    }

    public getSessionData$(): Observable<StripeAccountSessionResponse> {
        return this.financeStateService.getSessionData$();
    }

    public getSessionData(): StripeAccountSessionResponse {
        return this.financeStateService.getSessionData();
    }

    public resetSessionData() {
        this.financeStateService.setSessionData(new StripeAccountSessionResponse());
    }
}

